module.exports = __webpack_public_path__ + "img/car1.bbbed2d5.png";